import { render } from "./SubjectDetail.vue?vue&type=template&id=66aceda2"
import script from "./SubjectDetail.vue?vue&type=script&lang=js"
export * from "./SubjectDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__